<!--企业历程-->
<template>
  <div class="pi">

    <vue-seamless-scroll ref="seamlessScroll" class="warp" :data="piData" :class-option="{limitMoveNum: 5,direction: 2,step:0.8}">

      <ul class=" ul-item">
        <li  class="li-item" v-for="(item,index) in piData" :key="index">
          <div class="img">
            <img :src="item.backImg">
            <p class="eventTime">{{new Date(item.eventTime).Format("yyyy-MM")}}</p>
          </div>
          <div class="text">{{item.content}}</div>
        </li>
      </ul>

    </vue-seamless-scroll>



  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import api from '@/apis/CompanyProfile'
export default {
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      piData: [
        // {
        //   id: 0,
        //   pname: '电动固定螺杆空压机LGF-BP-6',
        //   pimg: require('@/assets/images/pic2.png'),
        // },
        // {
        //   id: 1,
        //   pname: '111电动固定螺杆空压机LGF-BP-6',
        //   pimg: require('@/assets/images/pic3.png'),
        // },
        // {
        //   id: 2,
        //   pname: '22电动固定螺杆空压机LGF-BP-6',
        //   pimg: require('@/assets/images/pic2.png'),
        // },
        // {
        //   id: 3,
        //   pname: '33电动固定螺杆空压机LGF-BP-6',
        //   pimg: require('@/assets/images/pic3.png'),
        // },
        // {
        //   id: 4,
        //   pname: '44电动固定螺杆空压机LGF-BP-6',
        //   pimg: require('@/assets/images/pic2.png'),
        // },
        // {
        //   id: 5,
        //   pname: '55电动固定螺杆空压机LGF-BP-6',
        //   pimg: require('@/assets/images/pic2.png'),
        // },
        // {
        //   id: 6,
        //   pname: '66电动固定螺杆空压机LGF-BP-6',
        //   pimg: require('@/assets/images/pic3.png'),
        // },
        // {
        //   id: 7,
        //   pname: '77电动固定螺杆空压机LGF-BP-6',
        //   pimg: require('@/assets/images/pic2.png'),
        // },
      ],
      productId: 0,
      productValue: {
        pimg: require('@/assets/images/pic2.png'),
        pname: '',
        content: '',
      },
      PIdialog: false,
      activeName: 'first',
    }
  },
  methods: {
    PIclick(id) {
      this.productId = id
      this.PIdialog = true
      this.productValue = this.piData[id]
    },
    PInext() {
      this.productId++
      if (this.productId >= this.piData.length) {
        this.productId = 0
      }
      this.productValue = this.piData[this.productId]
    },
  },
  mounted() {


      //企业历程
      api.course({
        params:{
          limit:100,
          page:1
        }
      }).then((res) => {
        if (res.code === 10000) {
          this.piData = res.data.list
        } else {
          this.$message.error(res.message)
        }
      })    



  },
}
</script>

<style lang="less" scoped>
.pi {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0.71rem;
  overflow: hidden;
  .preleft,
  .preright {
    position: absolute;
    top: 35%;
    width: 1.9rem;
    left: 10px;
    img {
      width: 100%;
    }
  }
  .preright {
    left: auto;
    right: 10px;
  }

  .warp {
    width: 100%;
    height: 100%;
    overflow: hidden;
    & > div {
      height: 100%;
    }
    .ul-item {
      list-style: none;
      padding: 0;
      margin: 0 auto;
      height: 100%;
      display: flex;
      .li-item {
        width: 12rem;
        height: 100%;
        margin-right: 10px;
        margin-right: 0.6rem;
        background-color: #999;
        color: #fff;
        display: flex;
        flex-direction: column;
        text-align: center;
        font-size: 30px;
        .img {
          flex: 1;
          overflow: hidden;
          width: 100%;
          // border: #3570ff solid 0.15rem;
          position: relative;
          .eventTime{
            position: absolute;
            width: 100%;
            bottom:0;
            background-color: #00000049;
            padding: 0.2rem 0;
            font-size: 1rem;
          }
          img {
            min-width: 100%;
            height: 100%;
          }
        }
        .text {
          width: 100%;
          text-align: center;
          height: 1.3rem;
          line-height: 1.3rem;
          font-size: 0.68rem;
          background: #01123a;
          color: #fff;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }

  .product {
    display: flex;
    flex-direction: row;
    overflow: hidden;
    img {
      width: 19rem;
      height: 16rem;
      margin-right: 1rem;
    }
    .right {
      flex: 1;
      overflow: hidden;
    }
  }
}
</style>
<style lang='less'>
.warp {
  & > div {
    height: 100%;
    & > div {
      height: 100%;
    }
  }
}
</style>